<template>
    <v-footer>
        <v-card elevation="0" rounded="0" width="100%" class="bg-grey text-center">
            <v-card-text class="text-white">
                @ {{ new Date().getFullYear() }}
                <p>Esse portfólio está constantemente sendo atualizado de acordo com minhas perspectivas
                    e ideias para
                    alimenta-lo, aceito sugestões, dicas e críticas construtivas para assim eu conseguir evoluir cada vez
                    mais e mais.</p>
                <p>Lembrando que todos os projetos que estão neste portfólio também estarão upados no <a
                        href="https://github.com/danillohss" target="_blank">GitHub</a></p>
                <strong>Portfólio versão 2.0</strong>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<style>
.v-footer {
    padding: 8px 0 !important;
}
</style>